import { ButtonLoading } from 'components/Buttons'
import { Modal } from 'components/Modal'
import { useQueueTickets } from 'store/useQueueTickets'
import { useWizardForm } from 'store/useWizardForm'
import FormattedMessage from 'utils/FormattedMessage'
import { CHOICE_STEP, useWizardSteps } from '../useWizardSteps'

export const TooManyPeopleWarning = () => {
  const { queue, goToStep } = useWizardSteps()
  const { wizardForm, updateWizardForm } = useWizardForm()
  const { queueTickets } = useQueueTickets()

  const open = Boolean(
    wizardForm.queueId === queue?.id &&
      queue?.isMaxLengthEnabled &&
      queue?.maxLength &&
      queueTickets?.length >= queue?.maxLength
  )

  const handleBackToChoices = () => {
    updateWizardForm({ queueId: undefined, queueType: undefined })
    goToStep(CHOICE_STEP)
  }

  return (
    <Modal open={open} closeIcon={false}>
      <div className='flex flex-col items-center bg-white p-5 w-full'>
        <img
          className='w-[150px] rounded-md mt-10 mb-7'
          src='/snail.svg'
          alt='Too many people'
        />
        <h1 className='text-gray-700 text-2xl font-bold text-center'>
          <FormattedMessage id='tooManyPeople' /> {':('}
        </h1>
        <p className='text-sm text-gray-800 text-center my-4 max-w-[80%]'>
          <FormattedMessage id='tooManyPeople.description' />
        </p>
        <ButtonLoading onClick={handleBackToChoices} style='w-full !mb-0 mt-6'>
          <FormattedMessage id='tooManyPeople.backButton' />
        </ButtonLoading>
      </div>
    </Modal>
  )
}
